import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { errMsg, useApi } from "@/lib/api";

const MeContext = createContext(null);

export function homePath(me) {
  if (!me) return "/";
  const { user, learner_profile, employer } = me;
  if (user.is_admin) return "/admin";
  if (!user.role_selected) return "/welcome";
  if (user.role === "employer") return employer?.onboarded ? "/employer" : "/onboarding/employer";
  return learner_profile?.onboarded ? "/learn" : "/onboarding/learner";
}

export function MeProvider({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      setMe(data);
      setError(null);
      return data;
    } catch (e) {
      setError(errMsg(e));
      return null;
    }
  }, [api]);

  useEffect(() => {
    if (isLoaded && isSignedIn) refresh();
    if (isLoaded && !isSignedIn) {
      setMe(null);
      setError(null);
    }
  }, [isLoaded, isSignedIn, refresh]);

  return <MeContext.Provider value={{ me, error, refresh }}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);
